import angular from 'angular';
import loanFacilityFees from './loanFacilityFees';

export default angular
  .module('loanProductFinder.scenes.loanFacilityFees', [])
  .component('loanFacilityFees', loanFacilityFees).name;
